import angular from 'angular'
import './notification_history.service'
import './edit/edit.controller'

angular
  .module('admin.notification_history', [
    'admin.notification_history.edit',
    'admin.notification_history.service',
  ])
  .controller('NotificationHistoryAdminCtrl', NotificationHistoryAdminCtrl)

/** @ngInject */
function NotificationHistoryAdminCtrl(
  $scope,
  $q,
  $state,
  $stateParams,
  NotificationsService,
  NotificationHistoryService,
  $interval,
) {
  var vm = this
  vm.items = []
  vm.userId = $stateParams.parentId
  vm.usersPerPage = 25
  vm.works = false

  vm.sortType = 'ts-m-desc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-p-desc'
  vm.sortReverse2 = false

  vm.create = function() {
    $state.go('admin.notifications')
  }

  function reloadPaginationDraft() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  loadPublished(1)
  loadUnpublished(1)

  var tab = localStorage.getItem('tabnotifications')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else {
      $('#draft').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function() {
    $('#published').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('tabnotifications', 'draft')
  }

  vm.tabPublished = function() {
    $('#draft').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('tabnotifications', 'published')
  }

  var oldSortType, oldSortType2
  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    NotificationHistoryService.listPublished(vm.oldPage2, 25, vm.sortType2).then(success)

    function success(result) {
      var pushs = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < pushs.length; i++) {
        if (pushs[i]['ts-p'] !== undefined) {
          pushs[i]['ts-p'] = new Date(
            parseInt(
              pushs[i]['ts-p'].toString().substring(0, pushs[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (pushs[i].st === 0) {
          pushs[i].status = 'Draft'
        } else if (pushs[i].st === 1) {
          pushs[i].status = 'Pending'
        } else if (pushs[i].st === 2) {
          pushs[i].status = 'Success'
        } else {
          pushs[i].status = 'Failed'
        }
        try {
          pushs[i].toName = JSON.parse(pushs[i].to).target
        } catch (error) {
          pushs.remove(pushs[i])
        }

        var users
        if (pushs[i].toName === 'users') {
          users = JSON.parse(pushs[i].to).users
          var concat = ''
          for (var j = 0; j < users.length; j++) {
            if (users.length === j + 1) {
              concat += users[j]
            } else {
              concat += users[j] + ','
            }
          }
          pushs[i].toName = concat
        } else if (pushs[i].toName === 'channels') {
          pushs[i].toName = JSON.parse(pushs[i].to).channels
          if (pushs[i].toName !== undefined) {
            pushs[i].toName = pushs[i].toName.substring(0, pushs[i].toName.length - 1)
          } else {
            pushs[i].toName = ''
          }
        }
      }
      vm.sortType2 = oldSortType2
      vm.itemsPublished = pushs
    }
  }

  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    NotificationHistoryService.listUnpublished(vm.oldPage, 25, vm.sortType).then(success)

    function success(result) {
      var pushs = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < pushs.length; i++) {
        if (pushs[i]['ts-p'] !== undefined) {
          pushs[i]['ts-p'] = new Date(
            parseInt(
              pushs[i]['ts-p'].toString().substring(0, pushs[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (pushs[i].st === 0) {
          pushs[i].status = 'Draft'
        } else if (pushs[i].st === 1) {
          pushs[i].status = 'Pending'
        } else if (pushs[i].st === 2) {
          pushs[i].status = 'Success'
        } else {
          pushs[i].status = 'Failed'
        }
        try {
          pushs[i].toName = JSON.parse(pushs[i].to).target
        } catch (error) {
          pushs.remove(pushs[i])
        }
        var users
        if (pushs[i].toName === 'users') {
          users = JSON.parse(pushs[i].to).users
          var concat = ''
          for (var j = 0; j < users.length; j++) {
            if (users.length === j + 1) {
              concat += users[j]
            } else {
              concat += users[j] + ','
            }
          }
          pushs[i].toName = concat
        } else if (pushs[i].toName === 'channels') {
          pushs[i].toName = JSON.parse(pushs[i].to).channels
          if (pushs[i].toName !== undefined) {
            pushs[i].toName = pushs[i].toName.substring(0, pushs[i].toName.length - 1)
          } else {
            pushs[i].toName = ''
          }
        }
      }
      vm.sortType = oldSortType
      vm.itemsDraft = pushs
    }
  }

  vm.pageChangedDraft = function(newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
  }

  vm.pageChangedPublished = function(newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          NotificationHistoryService.remove(item.id).then(function() {
            if (
              vm.itemsDraft.length === 1 ||
              vm.itemsPublished.length === 1 ||
              vm.itemsDraft.length === 25 ||
              vm.itemsPublished.length === 25
            ) {
              $state.reload()
            } else {
              vm.itemsDraft.remove(item)
              vm.itemsPublished.remove(item)
            }
          })
        } else {
          return
        }
      },
    )
  }

  vm.edit = function(item) {
    $state.go('admin.notification_history.edit', { id: item.id })
  }

  vm.publish = function(item) {
    vm.works = true
    var data = JSON.parse(item.to)
    if (item.dl === undefined || item.dl === null || item.dl === '') {
      swal("You can't publish push notification without deep link.", '', 'error')
      vm.works = false
      return
    }
    NotificationsService.send(data).then(
      function() {
        NotificationHistoryService.publish(item.id).then(function() {
          $state.reload()
          vm.works = false
        })
      },
      function() {
        NotificationHistoryService.update(item.id, { st: 3 }).then(function() {
          swal('Sorry. Push may have failed.', '', 'error')
          item.st = 3
          vm.works = false
        })
      },
    )
  }

  vm.clone = function(item, type) {
    var copy = angular.copy(item)
    delete copy.id
    delete copy['id-u']
    delete copy.ts
    delete copy['ts-m']
    delete copy['ts-p']
    delete copy.u
    copy.n = 1
    copy.st = 0
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          NotificationHistoryService.save(copy).then(function(result) {
            localStorage.setItem('tabnotifications', 'draft')
            if (type === 'draft') {
              $state.reload()
            } else {
              $state.reload()
            }
          })
        }
      },
    )
  }

  vm.unpublish = function(item) {
    NotificationHistoryService.unpublish(item.id).then(function() {
      vm.sortType = oldSortType
      vm.sortType2 = oldSortType2
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination.current)
    })
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 150,
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true
      vm.orderList(evt)
    },
  }

  var promise = []

  vm.orderList = function(evt) {
    if (evt.model === undefined) {
      return
    }

    evt.newIndex += 1
    evt.oldIndex += 1
    for (var i = 0; i < vm.itemsDraft.length; i++) {
      vm.itemsDraft[i].o = evt.newIndex
      if (vm.itemsDraft[i].id === evt.model.id) {
        promise.push(
          NotificationHistoryService.update(vm.itemsDraft[i].id, { n: vm.itemsDraft[i].o }),
        )
      }
    }

    for (var j = 0; j < vm.itemsDraft.length; j++) {
      if (vm.itemsDraft[j].n === evt.newIndex) {
        vm.itemsDraft[j].o = evt.oldIndex
        promise.push(
          NotificationHistoryService.update(vm.itemsDraft[j].id, { n: vm.itemsDraft[j].o }),
        )
      }
    }

    $q.all(promise).then(function() {
      vm.disableTable = false
    })
  }

  vm.update = function(model) {
    NotificationHistoryService.update(model.id, { n: model.o }).then(function() {})
  }

  vm.sort = function(type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadUnpublished(vm.pagination.current)
    } else {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    }
  }
}
